/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Warning_Overlap_TitleInputs */



/**
* | output |
* | --- |
* | "Overlaps detected" |
*
* @param {Event_Warning_Overlap_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_warning_overlap_title = /** @type {((inputs?: Event_Warning_Overlap_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Warning_Overlap_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chevauchements détectés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überlappungen erkannt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrapposizioni rilevate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружены пересечения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se detectaron superposiciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检测到重叠")
	if (locale === "ja") return /** @type {LocalizedString} */ ("重複が検出されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरलैप का पता चला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sobreposições detectadas")
	return /** @type {LocalizedString} */ ("Overlaps detected")
});